import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation('common');

  const languages = [
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'pt', name: 'Português', flag: '🇵🇹' },
    { code: 'zh-CN', name: '中文', flag: '🇨🇳' },
    { code: 'ja', name: '日本語', flag: '🇯🇵' },
    { code: 'hi', name: 'हिंदी', flag: '🇮🇳' },
    { code: 'ar', name: 'العربية', flag: '🇸🇦' },
  ];

  const changeLanguage = (languageCode) => {
    i18n.changeLanguage(languageCode);
  };

  const currentLanguage = languages.find(lang => 
    lang.code === i18n.language || lang.code === i18n.language.split('-')[0]
  ) || languages[0];

  return (
    <div className="language-switcher dropdown">
      <button
        className="btn btn-outline-secondary dropdown-toggle d-flex align-items-center"
        type="button"
        id="languageDropdown"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        title={t('language.current', { language: currentLanguage.name })}
      >
        <span className="me-2">{currentLanguage.flag}</span>
        <span className="d-none d-md-inline">{currentLanguage.name}</span>
      </button>
      <ul className="dropdown-menu" aria-labelledby="languageDropdown">
        {languages.map((language) => (
          <li key={language.code}>
            <button
              className={`dropdown-item d-flex align-items-center ${
                i18n.language === language.code || i18n.language.split('-')[0] === language.code ? 'active' : ''
              }`}
              onClick={() => changeLanguage(language.code)}
              title={t('language.switchTo', { language: language.name })}
            >
              <span className="me-2">{language.flag}</span>
              <span>{language.name}</span>
              {(i18n.language === language.code || i18n.language.split('-')[0] === language.code) && (
                <span className="ms-auto">
                  <i className="bi bi-check-lg"></i>
                </span>
              )}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LanguageSwitcher;